export default {
  form: {
    for_ceo: "For CEO",
  },
};
